<!--
    Program: EmToken.vue
    Author: SDL
    Description: 
    Created: 2020.03.20
-->

<template>
    <div>
        <div class="sub_tit mt25">Em Token Info</div>
        <!-- breadcrumbs -->
        <!-- srchTop_wrap -->
        <div class="srchTop_wrap">
            <article class="srch_basic">
                <div class="srch_grup">
                    <ul class="w49">
                        <li class="tit_150">Subsidiary</li>
                        <li data-input-type="select" class="w100-150">
                            <select
                                class="slt_white w100"
                                ref="selectCompany"
                                v-model="selectedCompany"
                            >
                                <option
                                    v-for="item in availableCompanyList"
                                    :key="item.CODE_ID"
                                    :value="item.CODE_ID"
                                >{{item.CODE_NAME}}</option>
                            </select>
                        </li>
                    </ul>
                    <ul class="w49">
                        <li class="tit_150">Country</li>
                        <li data-input-type="select" class="w100-150">
                            <select
                                ref="selectCountry"
                                class="slt_white w100 mr5"
                                v-model="selectedCountry"
                            >
                                <option
                                    v-for="item in availableCountryList"
                                    :key="item.CODE_ID"
                                    :value="item.CODE_ID"
                                >{{item.CODE_NAME}}</option>
                            </select>
                        </li>
                    </ul>
                    <ul class="w49">
                        <li class="tit_150">User</li>
                        <li data-input-type="select" class="w100-150">
                            <span class="clearable">
                                <input
                                    type="text"
                                    class="text_input w100"
                                    maxlength="20"
                                    placeholder
                                    v-model="userId"
                                    v-clearable
                                />
                            </span>
                        </li>
                    </ul>
                </div>
                <div class="srch_grupR">
                    <span class="btn">
                        <a href="javascript:" class="btn_srch" @click="onSearchClick">Search</a>
                    </span>
                </div>
            </article>
        </div>
        <!-- Grid -->
        <div class="grid_wrap">
            <!-- Grid Count-->
            <div class="grid_total">
                Total Count
                <em>{{ resultCount | numberFormat }}</em>
            </div>
            <!-- Grid -->
            <div id="grid">
                <toast-grid
                    gridId="gridEmToken"
                    ref="gridEmToken"
                    :key="gridKey"
                    :data="gridData"
                    :columns="gridColumns"
                    :options="gridOptions"
                    :pageOptions="gridPageOptions"
                    :theme="gridTheme"
                    :isTotalCount="false"
                    v-bind:click="onGridCellClick"
                />
            </div>

            <div class="paginate">
                <sdl-pagination
                    :current-page="currentPage"
                    :total-rows="resultCount"
                    :per-page="perPage"
                    @change="onGoToPage"
                    align="center"
                />
            </div>
        </div>
        <!-- Role tit -->
    </div>
</template>

<script>
import axios from 'axios';
import qs from 'query-string';
import { SDLUtil, StringUtil, DateUtil } from '@/utils';

import SKPBreadcrumbs from '~vb/main/SKPBreadcrumbs';

import Pagination from '@/components/common/control/pagination/Pagination';
import ToastGrid from '~c/ToastGrid';

import { CellHtmlRenderer } from '~c/GridCustomRenderer';

export default {
    name: 'emToken',
    components: {
        'skp-breadcrumbs': SKPBreadcrumbs,
        'toast-grid': ToastGrid,
        'sdl-pagination': Pagination,
    },
    props: {
        companyList: {
            type: Array,
            required: true,
        },
        countryList: {
            type: Array,
            required: true,
        },
    },
    computed: {},
    data() {
        return {
            pageTitle: '',

            availableCountryList: [],
            availableCompanyList: [],

            selectedCountry: 'ALL',
            selectedCompany: 'ALL',

            userId: '',

            resultCount: 0,

            currentPage: 1,
            perPage: parseInt(localStorage.getItem('listRows') || 50),

            gridKey: 0,
            gridData: [],

            gridColumns: [
                {
                    header: 'Subsidiary',
                    name: 'COMPANY_NM',
                    width: 120,
                    align: 'center',
                    resizable: false,
                    sortable: false,
                },
                {
                    header: 'Country',
                    name: 'COUNTRY_NM',
                    align: 'center',
                    resizable: false,
                    sortable: false,
                },
                {
                    header: 'User ID',
                    name: 'LOGIN_ID',
                    align: 'center',
                    resizable: false,
                    sortable: false,
                },
                {
                    header: 'Register',
                    name: 'REGISTER_HTML',
                    width: 160,
                    align: 'center',
                    resizable: false,
                    sortable: false,
                    renderer: CellHtmlRenderer,
                },
            ],
            gridOptions: {
                scrollX: false,
                scrollY: false,
            },
            gridPageOptions: null,
            gridTheme: {
                name: 'skpTheme', // required
                value: {
                    // required
                    row: {
                        hover: {
                            background: '#FBFBFC',
                        },
                    },
                    // cell: {
                    //     normal: {
                    //         background: '#00ff00',
                    //         border: '#e0e0e0'
                    //     },
                    //     head: {
                    //         background: '#ff0000',
                    //         border: '#ffff00'
                    //     },
                    // },
                },
            },
        };
    },
    created() {
        console.log('Component: emToken created. ');
    },
    mounted() {
        console.log('Component: emToken mounted.');
        this.init();
    },
    methods: {
        async init() {
            // const data = await this.fetchInitData();
            // if (data == null) return;
            this.setCountryList(this.countryList);
            this.setCompanyList(this.companyList);
        },

        setCompanyList(list) {
            // list = list.map(item => {
            //     return {
            //         CODE_ID: item.COMPANY,
            //         CODE_NAME: item.COMPANY_NM,
            //     };
            // });

            // list.unshift({
            //     CODE_ID: 'ALL',
            //     CODE_NAME: 'ALL',
            // });

            this.availableCompanyList = list;
        },

        setCountryList(list) {
            // list = list.map(item => {
            //     return {
            //         CODE_ID: item.CDCODE,
            //         CODE_NAME: item.CDDESC,
            //     };
            // });

            // list.unshift({
            //     CODE_ID: 'ALL',
            //     CODE_NAME: 'ALL',
            // });

            this.availableCountryList = list;
        },

        onSearchClick() {
            this.doSearch(1);
        },

        async doSearch(pageNo) {
            const params = this.prepSearchParams(pageNo);
            SDLUtil.showLoadingBar(true);
            const data = await this.fetchSearchResult(params);
            this.setSearchResult(data);
            this.currentPage = pageNo;
            // this.lastSearchParams = params;
            SDLUtil.showLoadingBar(false);
        },

        prepSearchParams(pageNo) {
            if (!pageNo) pageNo = 1;

            const params = {
                page: pageNo,
                login_id: this.userId,
                country: this.selectedCountry,
                company: this.selectedCompany,
            };

            console.log('search params', params);
            return params;
        },

        fetchSearchResult(formData) {
            return SDLUtil.postForm('/basis/anysvcmobile/EmToken/EmTokenUserSearch.skp', formData);
        },

        setSearchResult(data) {
            this.resultCount = data.count;
            this.gridData = data.rows.map(row => {
                row.REGISTER_HTML = `<a href="javascript:" class="btn_sm_white">Add</a>`;
                return row;
            });
            this.gridKey += 1;
        },

        onGoToPage(pageNo) {
            // this.lastSearchParams.page = pageNo;
            this.doSearch(pageNo);
        },

        onGridCellClick(event, rowData) {
            console.log(event);
            if (typeof event.rowKey === 'undefined') return;
            const row = rowData[event.rowKey];
            // console.log('event rowKey', event.rowKey);
            // console.log('event columnName', event.columnName);
            // console.log('event rowData', rowData);
            console.log('event row', rowData[event.rowKey]);
            if (event.columnName === 'REGISTER_HTML') {
                this.insertEmToken(row.LOGIN_CORP, row.LOGIN_ID);
            }
        },

        insertEmToken(company, loginId) {
            SDLUtil.showLoadingBar(true);
            const formData = {
                company: company,
                login_id: loginId,
            };
            return SDLUtil.postForm('/basis/anysvcmobile/EmToken/InsertEmToken.skp', formData)
                .then(data => {
                    SDLUtil.showLoadingBar(false);
                    // if (typeof data.count === undefined || data.count !== 1) {
                    //     SDLUtil.alert({
                    //         title: 'Failed!',
                    //         msg: `Insertion has failed!<br>Count: ${data.count}`,
                    //     });
                    //     return;
                    // }

                    SDLUtil.alert({
                        title: 'Success!',
                        msg: `Insertion complete!`,
                        onOkEvt: () => {
                            this.doSearch(1);
                        },
                    });
                })
                .catch(err => {
                    console.log('err', err);
                    SDLUtil.showLoadingBar(false);
                    if (err.data.error.code === 'HHP_INVALID_REQUEST') {
                        const msg = err.data.error.message;
                        SDLUtil.alert({
                            title: 'Invalid!',
                            msg,
                            onOkEvt: () => {},
                        });
                    }
                });
        },
    },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/anysvcmobile/emToken/EmTokenUser.vue